import { render, staticRenderFns } from "./WarehouseNew_Details.vue?vue&type=template&id=f8b22244&"
import script from "./WarehouseNew_Details.vue?vue&type=script&lang=js&"
export * from "./WarehouseNew_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports